export default {
  all: state => state.all,
  single: state => state.single,
  owners: state => state.owners,
  metaDataFields: state => state.metaDataFields
}
